import axios from 'axios'
import Swal from 'sweetalert2'

axios.defaults.baseURL = process.env.REACT_APP_API_BASE

axios.interceptors.request.use((config) => {
  config.params = { ...config.params, lang: 'en' }
  return config
})

axios.interceptors.response.use(
  (response) => {
    if (response.status === 200 && response.data.messages?.[3]) {
      Swal.fire({
        title: 'Success',
        text: response.data.messages[3].join('<br/>'),
        icon: 'success',
      })
    }
    return response
  },
  (error) => {
    if (error.response) {
      const status = error.response.status
      const data = error.response.data
      if (status === 401) {
        Swal.fire({
          title: 'Error',
          text: data.message,
          icon: 'error',
        }).then(() => {
          localStorage.removeItem('@auth/token')
        })
      } else if (status === 400) {
        if (data.message === 'Expired JWT Token') {
          Swal.fire({
            title: 'Error',
            text: data.message,
            icon: 'error',
          }).then(() => {
            localStorage.removeItem('@auth/token')
          })
        } else {
          return error.response
        }
      } else {
        return error.response
      }
    }
    return
  }
)
